import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/legalBilling/legalBilling.query.gql"
import type {
  LegalBillingQuery,
  LegalBillingQueryVariables,
} from "@/v2-backoffice-client/legalBilling/__types__/legalBilling.query"

type Options = QueryHookOptions<LegalBillingQuery, LegalBillingQueryVariables>

// useLegalBillingQuery reads every tenant's land-register document purchases for a date
// range, pre-grouped tenant → tag → batch by the API.
//
// The range is required by the schema, so callers must not fire this before the filter is
// valid (`isValidBillingRange`) — an all-tenants read is the one query here whose cost
// scales with the window.
export function useLegalBillingQuery(options?: Options) {
  return useQuery<LegalBillingQuery, LegalBillingQueryVariables>(query, options)
}

// LEGAL_BILLING_REFETCH_QUERIES is what the mark/unmark mutation refetches. Marking
// changes rollups at four nesting levels at once, so refetching the range beats trying to
// patch the normalised cache — and it doubles as the staleness fix when UpdatedCount comes
// back lower than the number of ids sent.
export const LEGAL_BILLING_REFETCH_QUERIES = ["LegalBillingQuery"] as const
